import { combineReducers } from 'redux';
import product from './product';
import navigation from './shared/navigation';
import search from './shared/search';
import banner from './shared/banner';
import footer from './shared/footer';
import products from './products';
import popup from './Popup';
import modals from './modal';
import loaders from './loaders';
import recentlyViewed from './recentlyViewed';
import error from './error';
import HomeReducer from './shared/HomeReducer';
import minicart from './shared/minicart';
import httpError from './shared/HTTPError';
import counter from './shared/counter';
import grid from './shared/grid';
import request from './shared/request';
import sorts from './shared/sorts';
import facets from './shared/facets';
import productsAdditionalInfo from './shared/productsAdditionalInfo';
import seoMetaData from './shared/seoMetaData';
import plpOnLanding from './shared/plpOnLanding';
import dynamicComponent from './dynamicImport';
import events from './events';
import capsules from './shared/capsules';
import token from './shared/token';
import accordions from './shared/accordion';
import storeCredit from './shared/storeCredit';
import flags from './shared/flags';
import variants from './shared/variants';
import apiErrorReducer from './shared/apiErrorReducer';
import location from './shared/location';

import cart from '../cart/reducers/cart';
import inventory from '../cart/reducers/inventoryCheck';
import cartItem from '../cart/reducers/productInCart';
import giftItem from '../cart/reducers/giftInCart';
import voucher from '../cart/reducers/voucher';
import addressBook from '../myaccount/reducers/addressBook';
import personalInfo from '../myaccount/reducers/personalInfo';
import bannerInfo from '../myaccount/reducers/bannerInfo';
import paymentInfo from '../myaccount/reducers/paymentInfo';
import ordersData from '../myaccount/reducers/ordersData';
import payment from '../checkout/reducers/payment';
import creditsData from '../myaccount/reducers/creditsData';
import signInReducer from '../userauth/reducers/signInReducer';
import signInOTPReducer from '../userauth/reducers/signInOTPReducer';
import signUpReducer from '../userauth/reducers/signUpReducer';
import userInfoReducer from '../userauth/reducers/userInfoReducer';
import selfcare from '../selfcare/reducers/selfcare';
import order from '../checkout/reducers/order';
import returnExchange from '../myorders/reducers/returnExchange';
import returnItemsUserScreenshotsReducer from '../myorders/reducers/returnItemsUserScreenshotsReducer';
import jioprime from '../jioprime/reducers/jioprime';
import webMetaData from './shared/webMetaData';
import eossPromoReducer from './shared/eossPromoReducer';
import eossCouponsReducer from './shared/eossCouponsReducer';
import ajioWalletData from '../myaccount/reducers/ajioWalletData';
import ajioGiftCardData from '../myaccount/reducers/ajioGiftCardData';
import wishlist from '../wishlist/reducers/wishlist';
// import newsletter from "./shared/newsletter";
import edd from '../edd/reducers/index.js';
import offerReducer from '../offers/reducer';
import { spinTheWheelReducer } from '../games/stw/reducers/spinTheWheelReducer';
import { myRewardsReducer } from '../myaccount/reducers/myRewardsReducer';
import referAndEarn from '../myaccount/reducers/referAndEarn';
import ajioCashTrxnHistory from '../myaccount/reducers/ajioCashTrxnHistoryV2';
import scratchCardReducer from '../games/scratchcard/reducer/scratchCardReducer';
import topShopperReducer from './topShopperReducer';
import bannerProducts from './bannerProducts';
import plpExtendedBanner from './plpExtendedBanner';
import assuredGifts from './assuredGiftsReducer';
import RecentSearches from './shared/recentSearch';
import ratingsReducers from './shared/ratings';
import jioAds from './shared/jioAds';
import cmsAdsReducer from './shared/cmsAdsReducer';
import ajioWalletDataBottomStrip from './shared/ajioWalletDataBottomStrip';
import mobileBottomNavReducer from './mobile/mobileBottomNavReducer';
import cacheData from './shared/cacheData';
import membershipReducer from './shared/membershipReducer';
import { apiCallReducer, dressToolFlagReducer, stepsReducer } from './shared/braRecommendation';
import { rushAddressBarFlagReducer, rushDeliveryTypeReducer } from './shared/ajioRush';
import recommendationWidgetReducer from './shared/recommendationWidget';
import internalWalletDetails from '../cart/reducers/internalWallet';
import gst from '../cart/reducers/gst';

const rootReducer = combineReducers({
  wishlist,
  navigation,
  search,
  banner,
  footer,
  products,
  capsules,
  product,
  popup,
  modals,
  loaders,
  error,
  recentlyViewed,
  minicart,
  HomeReducer,
  httpError,
  counter,
  grid,
  request,
  sorts,
  facets,
  productsAdditionalInfo,
  seoMetaData,
  plpOnLanding,
  dynamicComponent,
  events,
  cart,
  cartItem,
  giftItem,
  voucher,
  addressBook,
  token,
  personalInfo,
  ordersData,
  payment,
  creditsData,
  signInReducer,
  signInOTPReducer,
  signUpReducer,
  accordions,
  storeCredit,
  userInfoReducer,
  selfcare,
  order,
  returnExchange,
  returnItemsUserScreenshots: returnItemsUserScreenshotsReducer,
  jioprime,
  metaData: webMetaData,
  events,
  eossPromoReducer,
  eossCouponsReducer,
  ajioWalletData,
  ajioGiftCardData,
  edd,
  bannerInfo,
  paymentInfo,
  offer: offerReducer,
  flags,
  variants,
  cartInventory: inventory,
  spinTheWheel: spinTheWheelReducer,
  myRewards: myRewardsReducer,
  referAndEarn,
  ajioCashTrxnHistory,
  topShoppers: topShopperReducer,
  scratchCard: scratchCardReducer,
  bannerProducts,
  plpExtendedBanner,
  assuredGifts,
  RecentSearches,
  ratings: ratingsReducers,
  jioAds,
  bottomNavList: mobileBottomNavReducer,
  apiErrors: apiErrorReducer,
  location,
  cacheData,
  membership: membershipReducer,
  stepsReducer,
  apiCallReducer,
  dressToolFlagReducer,
  cmsAds: cmsAdsReducer,
  rushAddressBarFlagReducer,
  rushDeliveryTypeReducer,
  ajioWalletDataBottomStrip,
  recommendatioWidget: recommendationWidgetReducer,
  widgets: recommendationWidgetReducer,
  internalWalletDetails,
  gst
});

export default rootReducer;
